var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapZoomOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7778 0H4.22222C1.89035 0 0 1.9401 0 4.33333V34.6667C0 37.0599 1.89035 39 4.22222 39H33.7778C36.1096 39 38 37.0599 38 34.6667V4.33333C38 1.9401 36.1096 0 33.7778 0Z",
    fill: "#002B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.1641H28.334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapZoomOut);
export default __webpack_public_path__ + "static/media/MapZoomOut.0a42a1c5e19bc3cae7dbdee24a6d7be3.svg";
export { ForwardRef as ReactComponent };